import { RestUrl } from "@/commons/constants/RestUrl";
import UrlFormatter from "@/commons/utils/UrlFormatter";
import CommonService from "@/commons/services/CommonService";
import LoginUser from "@/store/LoginUser";
import { HitomeqErrorType } from "@/commons/models/SystemError";

/**
 * ### 地域情報 API 操作クラス
 */
export default class RegionMasters {
  /** 共通サービス */
  private commonService: CommonService;

  /**
   * ### コンストラクター
   *
   * - 共通サービスが渡されればそれを使用する
   * - 共通サービスが渡されなければ新しいインスタンスを作る
   *
   * @param commonService 共通サービス
   */
  constructor(commonService?: CommonService) {
    this.commonService = commonService ? commonService : new CommonService();
    return;
  }

  /**
   * ### GET RegionMasters
   */
  public async gets(userStore: LoginUser): Promise<Array<RegionMastersGetModel>> {
    const formatParams: any = {
      facilityId: userStore.loginUser.facilityId
    };
    const requestUrl: string = UrlFormatter.format(RestUrl.RegionMasters, formatParams);
    const response = await this.commonService.executeGet<Array<RegionMastersGetModel>>(userStore, requestUrl, this.constructor.name, {}, HitomeqErrorType.REQUEST_RETRY, 0);

    return response.data;
  }
}

export interface RegionMastersGetModel {
  /** 都道府県 */
  prefecture: RegionMaster;
  /** 市区町村 */
  municipalities: Array<RegionMaster>;
}

export interface RegionMaster {
  /** パーティションキー */
  regionMastersKey: string;
  /** ソートキー */
  regionMastersSortKey: string;
  /** 都道府県コード */
  prefectureCode: string;
  /** 市区町村コード */
  municipalityCode: string;
  /** 都道府県なのか、市区町村なのかを指す文字列 */
  type: RegionMasterType;
  /** 都道府県または市区町村の名称 */
  name: string;
  /** 都道府県または市区町村の名称（カナ） */
  kanaName: string;
  /** 地方公共団体コード */
  code: string;

  /** 作成日時 */
  created: number;
  /** 更新日時 */
  updated: number;
}

export enum RegionMasterType {
  /** 都道府県 */
  PREFECTURE = "prefecture",
  /** 市区町村 */
  MUNICIPALITY = "municipality"
}
